// extracted by mini-css-extract-plugin
module.exports = {"tooltipBase":"styles-module_tooltipBase__OckViToKgeKK76dvJR2Lj"};